/*
 * Accolad UCD — Solution : animation smooth de l'accordéon mobile/tablette.
 *
 * Progressive enhancement : le markup reste des <details name="accolad-solution-acc">
 * pleinement fonctionnels sans JS (exclusivité + ouverture/fermeture natives, "snap").
 * Si ce script charge, il prend la main pour animer la hauteur des panneaux.
 *
 * État géré via data-attributes (aucune classe CSS requise) :
 *   - data-acc-animated="true" sur .accolad-ucd-solution-accordion → garde anti double-init
 *   - data-animating="true"     sur un .accolad-ucd-solution-acc-item pendant sa transition
 *
 * Respecte prefers-reduced-motion: reduce (bascule open/close instantanée, sans animation).
 */
(function () {
  function setup(scope) {
    var container = (scope || document).querySelector('.accolad-ucd-solution-accordion');
    if (!container) return;
    if (container.dataset.accAnimated === 'true') return; // anti double-init (Theme Editor reload)
    container.dataset.accAnimated = 'true';

    var items = Array.prototype.slice.call(
      container.querySelectorAll('.accolad-ucd-solution-acc-item')
    );
    if (!items.length) return;

    var reduceMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // JS prend la main sur l'exclusivité : on retire l'attribut name natif, sinon le
    // groupe exclusif fermerait le panneau précédent instantanément (sans animation).
    // Le fallback no-JS garde name="..." dans le HTML rendu.
    items.forEach(function (d) { d.removeAttribute('name'); });

    function panelOf(d) {
      return d.querySelector('.accolad-ucd-solution-acc-panel');
    }

    function openItem(d) {
      var panel = panelOf(d);
      if (!panel || reduceMotion) { d.open = true; return; }
      d.open = true;                       // rend le contenu (avant tout paint)
      d.dataset.animating = 'true';
      panel.style.height = '0px';          // état de départ, même tick → pas de flash
      panel.style.opacity = '0';
      var target = panel.scrollHeight;     // hauteur cible (contenu complet)
      requestAnimationFrame(function () {
        panel.style.height = target + 'px';
        panel.style.opacity = '1';
      });
      panel.addEventListener('transitionend', function onEnd(ev) {
        if (ev.target !== panel || ev.propertyName !== 'height') return;
        panel.style.height = '';           // rend la hauteur "auto"
        panel.style.opacity = '';
        delete d.dataset.animating;
        panel.removeEventListener('transitionend', onEnd);
      });
    }

    function closeItem(d) {
      var panel = panelOf(d);
      if (!panel || reduceMotion) { d.open = false; return; }
      d.dataset.animating = 'true';
      panel.style.height = panel.scrollHeight + 'px';
      panel.style.opacity = '1';
      panel.getBoundingClientRect();       // reflow pour figer la hauteur de départ
      requestAnimationFrame(function () {
        panel.style.height = '0px';
        panel.style.opacity = '0';
      });
      panel.addEventListener('transitionend', function onEnd(ev) {
        if (ev.target !== panel || ev.propertyName !== 'height') return;
        d.open = false;                    // ferme réellement à la fin de l'anim
        panel.style.height = '';
        panel.style.opacity = '';
        delete d.dataset.animating;
        panel.removeEventListener('transitionend', onEnd);
      });
    }

    items.forEach(function (d) {
      var summary = d.querySelector('.accolad-ucd-solution-acc-summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();                // on contrôle le toggle nous-mêmes
        if (d.dataset.animating) return;   // ignore pendant une transition en cours
        if (d.open) {
          closeItem(d);                    // clic sur l'item ouvert → tout fermé possible
        } else {
          items.forEach(function (o) {     // exclusivité : ferme l'autre étape ouverte
            if (o !== d && o.open && !o.dataset.animating) closeItem(o);
          });
          openItem(d);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }
  // Theme Editor : ré-init sur la section rechargée (DOM neuf, garde anti double-init).
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
